module.exports = __webpack_public_path__ + "static/media/water-flow.d4ed399d.png";